import * as tslib_1 from "tslib";
import { lazyHideFlexPane, lazyShowFlexPane } from 'owa-flex-pane';
import strings from 'owa-strings/owa-common-strings';
import { TodoPanel } from 'owa-todos';
import * as React from 'react';
var styles = require('./TodoPane.scss');
var TodoPane = /** @class */ (function (_super) {
    tslib_1.__extends(TodoPane, _super);
    function TodoPane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TodoPane.prototype.componentDidMount = function () {
        lazyShowFlexPane.importAndExecute(React.createElement("div", { className: styles.todosPane },
            React.createElement(TodoPanel, null)), {
            headerText: strings.panelHeaderText,
            onDismiss: this.props.onDismiss,
            className: styles.todoFlex,
        });
    };
    TodoPane.prototype.componentWillUnmount = function () {
        lazyHideFlexPane.importAndExecute();
    };
    TodoPane.prototype.render = function () {
        return null;
    };
    return TodoPane;
}(React.Component));
export default TodoPane;
//# sourceMappingURL=TodoPane.js.map